<template>
  <div>
    <div v-if="hasResults">
      <div
        v-for="(detail, index) in results"
        :key="index"
        class="mb-3 custom-callout "
        :controlled="false"
      >
        <div class="row border-bottom bg-gray p-3  mt-3">
          <div class="col-sm border-r">
            <div class="bold font-16">{{ detail.name }}</div>
            <div class="color-secondary-6 font-14">
              {{ detail.model }}
            </div>
          </div>
          <div class="col-sm ">
            <div class="color-secondary-6 font-14">
              Estatus:
            </div>
            <div class="bold" v-if="assigned">
              <span class="d-flex align-items-center">
                <div
                  class="status-indicator"
                  :style="{
                    backgroundColor: '#DDB3D7',
                  }"
                >
                  &nbsp;
                </div>
                <span class="text font-weight-bold">
                  Asignado
                </span>
              </span>
            </div>
            <div class="bold" v-if="!assigned">
              <span class="d-flex align-items-center">
                <div
                  class="status-indicator"
                  :style="{
                    backgroundColor:
                      detail.availableQuantity > 0 ? '#A3E5B3' : '#D5B89A',
                  }"
                >
                  &nbsp;
                </div>
                <span class="text font-weight-bold">
                  {{
                    detail.availableQuantity > 0
                      ? 'Disponible'
                      : 'No Disponible'
                  }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-sm " v-if="!assigned">
            <div class="color-secondary-6 font-14">
              Cantidad en Inventario:
            </div>
            <div>
              {{ detail.quantity }}
            </div>
          </div>
          <div class="col-sm " v-if="!assigned">
            <div class="color-secondary-6 font-14">
              Cantidad Disponible:
            </div>
            <div>
              {{ detail.quantity - detail.assignedQuantity }}
            </div>
          </div>
          <div class="col-sm " v-if="!assigned">
            <div class="color-secondary-6 font-14">
              Cantidad Asignada:
            </div>
            <div>
              {{ detail.assignedQuantity }}
            </div>
          </div>
          <div class="col-sm text-right">
            <action-button
              v-if="assigned || detail.quantity - detail.assignedQuantity > 0"
              id="modal-btn-anadir"
              :variant="
                !detail.isSelected
                  ? 'outline-success ' + (isMobile ? 'w-100 mt-4' : '')
                  : 'success ' + (isMobile ? 'w-100  mt-4' : '')
              "
              type="button"
              i="fas fa-check"
              data-target="#modal-cambiar"
              @click="onSelectAccessory(index)"
            >
              {{ detail.isSelected ? 'Seleccionado' : 'Seleccionar' }}
            </action-button>
          </div>
        </div>
      </div>

      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="onPageChange"
      />
    </div>
    <custom-result-not-found v-else text="No hay Información Disponible." />
    <div class="row" v-if="!hideButtons">
      <div class="text-right col-12 p-0">
        <action-button
          :variant="isMobile ? 'outline-danger w-100' : 'outline-danger'"
          i="fas fa-times-circle"
          @click="onCancel()"
        >
          Cancelar
        </action-button>
        <action-button
          :variant="isMobile ? 'success w-100 mt-2' : 'success ml-md-2 '"
          type="button"
          i="fas fa-save"
          @click="onAssignEquipment()"
        >
          Guardar
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';
import service from '@/services/api/inventorycatalog.api';
import { ActionButton } from '@/components/common';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import mixAlert from '@/mixins/alert.mixin';

export default {
  name: 'Accessories',
  components: {
    CustomResultNotFound,
    Pagination,
    ActionButton,
  },
  mixins: [mixAlert],
  props: {
    equipment: {
      type: Object,
      required: true,
    },
    recommendation: {
      type: Object,
      required: false,
      default: { referral: {} },
    },
    hideButtons: {
      type: Boolean,
      required: false,
      default: false,
    },
    assigned: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    hasResults() {
      return Boolean(this.results?.length);
    },
  },
  data: () => ({
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: 5,
    },
    results: [],
    unSelectedItems: [],
  }),
  async mounted() {
    await this.search(1);
  },
  methods: {
    async onAssignEquipment() {
      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea asignar el equipo <strong> ${this.equipment.name} </strong> al estudiante  <strong>${this.recommendation.referral.studentName}/${this.recommendation.referral.referralNumber}</strong>?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) {
        return;
      }
      var payload = {
        recommendationId: this.recommendation.id,
        equipmentId: this.equipment.id,
        UnselectedAccessories: this.unSelectedItems,
      };
      service
        .assignEquipment(payload)
        .then(() => {
          this.ShowToast(
            'Éxito',
            'El equipo ha sido asignado exitosamente.',
            'success'
          );
          this.recommendation.equipmentId = this.equipment.id;
          this.$emit('close');
        })
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
    },
    onCancel() {
      this.$emit('close');
    },
    onSelectAccessory(index) {
      const item = this.results[index];
      item.isSelected = !item.isSelected;
      if (!item.isSelected) {
        this.unSelectedItems.push(item.id);
      } else {
        const i = this.unSelectedItems.findIndex((x) => x === item.id);
        if (i >= 0) this.unSelectedItems.splice(i, 1);
      }
      this.$emit('onSelectAccessory', this.unSelectedItems);
      this.$forceUpdate();
    },
    async onPageChange(page) {
      this.search(page);
    },
    async search(page = 1) {
      const { data: result } = await service.getAccessoriesByEquipment(
        this.equipment.id,
        page,
        this.pagination.pageSize
      );
      if (this.assigned) {
        result.data = result.data.filter((x) => x.assigned);
      }
      this.results = result.data.map((x) => ({ ...x, isSelected: true }));
      this.pagination = {
        pageSize: 5,
        totalItemCount: result.totalItemCount,
        pageCount: result.pageCount,
        currentPage: result.currentPage,
        count: result.count,
      };

      if (!this.hasResults) {
        this.$emit('hideButtons');
      }
    },
  },
};
</script>

<style lang="scss">
.status-balloon-container {
  margin-right: 10px;
  padding: 5px;
  text-align: center;
  color: #11291b;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 900;
  width: 100%;
  width: unset;
}

.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.border-r:not(:last-child) {
  border-right: 1px solid #b5c3bc;
}
</style>
